// src/pages/Dashboard/NotificationCard.jsx
import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import ButtonEyeNoRead from "../../components/Button/ButtonEyeNoRead";
import ButtonEyeRead from "../../components/Button/ButtonEyeRead";
import ButtonDelete from "../../components/Button/ButtonDelete";
import "./NotificationCard.css";

const NotificationCard = ({
  notification,
  toggleReadStatus,
  handleDeleteNotification,
}) => {
  const [swipeDirection, setSwipeDirection] = useState(null);

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      setSwipeDirection("left");
      setTimeout(() => {
        toggleReadStatus(notification.id);
        setSwipeDirection(null);
      }, 200);
    },
    onSwipedRight: () => {
      setSwipeDirection("right");
      setTimeout(() => {
        handleDeleteNotification(notification.id);
        setSwipeDirection(null);
      }, 200);
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  return (
    <div
      className={`notification-card rounded-xl border border-slate-200 dark:border-slate-700 p-3 mb-3 shadow-sm transition-colors ${
        notification.read_notification
          ? "bg-white dark:bg-slate-900"
          : "bg-primary/5 dark:bg-primary/15"
      } ${swipeDirection === "left" ? "swipe-left" : ""} ${
        swipeDirection === "right" ? "swipe-right" : ""
      }`}
      {...handlers}
    >
      <div className="flex justify-between items-center mb-2">
        <span className="text-xs font-semibold text-slate-700 dark:text-slate-200">
          {new Date(notification.created_at).toLocaleDateString("fr-FR", {
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
          })}
        </span>
        <div className="flex space-x-1.5">
          {notification.read_notification ? (
            <ButtonEyeRead
              onClick={() => toggleReadStatus(notification.id)}
              hoverLabel="Marquer comme non lu"
            />
          ) : (
            <ButtonEyeNoRead
              onClick={() => toggleReadStatus(notification.id)}
              hoverLabel="Marquer comme lu"
            />
          )}
          <ButtonDelete
            onClick={() => handleDeleteNotification(notification.id)}
            hoverLabel="Supprimer"
          />
        </div>
      </div>

      <div className="text-xs text-slate-700 dark:text-slate-200 break-words">
        {notification.message}
      </div>
    </div>
  );
};

export default NotificationCard;
